import React from 'react';
import { Loader2, Mic, Square } from 'lucide-react';

// Tap to start, tap to stop (max 2 min). Sits beside the task description box.
export const VoiceCaptureButton = ({ capture, disabled }) => {
  const { isRecording, elapsed, maxSeconds, processing, permission, toggle } = capture;
  const remaining = Math.max(0, maxSeconds - Math.floor(elapsed));
  const label = isRecording
    ? `Listening… ${Math.floor(elapsed)}s (tap to finish, ${remaining}s left)`
    : processing ? 'Turning your words into tasks…' : 'Tap to describe tasks by voice';
  return (
    <div className="voice-capture" data-testid="voice-capture">
      <button
        type="button"
        className={`voice-capture-btn ${isRecording ? 'recording' : ''}`}
        onClick={toggle}
        disabled={disabled || processing}
        aria-pressed={isRecording}
        aria-label={isRecording ? 'Stop recording' : 'Record tasks by voice'}
        title={label}
        data-testid="voice-task-button"
      >
        {processing ? <Loader2 size={22} className="animate-spin" /> : isRecording ? <Square size={20} /> : <Mic size={22} />}
        {isRecording && (
          <svg className="voice-capture-ring" viewBox="0 0 100 100" aria-hidden="true">
            <circle cx="50" cy="50" r="46" style={{ strokeDasharray: 289, strokeDashoffset: 289 * (1 - Math.min(elapsed / maxSeconds, 1)) }} />
          </svg>
        )}
      </button>
      <div className={`voice-capture-status ${isRecording ? 'recording' : ''}`} data-testid="voice-task-status">
        {isRecording && <span className="rec-dot" />}
        {label}
      </div>
      {permission === 'denied' && (
        <div className="voice-capture-help" data-testid="voice-task-permission-help">
          Microphone blocked. Allow it for this site in your browser settings, then try again.
        </div>
      )}
    </div>
  );
};
